import React from 'react'
import { FieldWrapper, SegmentedControl } from '../../../shared/ui'
import { FilterBar } from '../../../shared/ui/layouts/FilterBar'
import Select from '../../../shared/ui/controls/Select/Select'
import { MultiSelectDropdown } from '../../../shared/ui/controls/MultiSelectDropdown'
import { HandwerkerSearchSelect } from '../../../entities/user'
import { monthLongLabel, type GewerkOption } from '../../../entities/dashboard'
import {
  DASHBOARD_FIRST_YEAR,
  DASHBOARD_START_MONTH,
  DashboardFiltersForm,
  DashboardPeriodMode,
} from '../model/dashboardFilters.types'
import type { DashboardFiltersActions } from '../model/useDashboardFilters'

interface Props {
  filters: DashboardFiltersForm
  actions: DashboardFiltersActions
  gewerkOptions: GewerkOption[]
  yearOptions: number[]
  monthOptions: string[]
}

const MODE_ITEMS: { label: string; value: DashboardPeriodMode }[] = [
  { label: 'Jahr', value: 'year' },
  { label: 'Monate', value: 'months' },
]

export const DashboardFilterBar: React.FC<Props> = ({
  filters,
  actions,
  gewerkOptions,
  yearOptions,
  monthOptions,
}) => {
  const monthSelectOptions = monthOptions.map((m) => ({ value: m, label: monthLongLabel(m) }))
  const yearSelectOptions = yearOptions.map((y) => ({
    value: String(y),
    label: y === DASHBOARD_FIRST_YEAR ? `${y} (ab ${DASHBOARD_START_MONTH.slice(5, 7)}/${y})` : String(y),
  }))

  return (
    <FilterBar minColWidth="160px" gap={12} rowGap={8}>
      <FieldWrapper label="Zeitraum">
        <SegmentedControl
          items={MODE_ITEMS}
          value={filters.mode}
          onChange={actions.setMode}
          ariaLabel="Art des Zeitraums"
        />
      </FieldWrapper>

      {filters.mode === 'year' ? (
        <FieldWrapper label="Jahr">
          <Select
            options={yearSelectOptions}
            value={String(filters.year)}
            onChange={(v) => v != null && actions.setYear(Number(v))}
          />
        </FieldWrapper>
      ) : (
        <>
          <FieldWrapper label="Von">
            <Select
              options={monthSelectOptions}
              value={filters.from}
              onChange={(v) => v != null && actions.setFrom(String(v))}
            />
          </FieldWrapper>
          <FieldWrapper label="Bis">
            <Select
              options={monthSelectOptions}
              value={filters.to}
              onChange={(v) => v != null && actions.setTo(String(v))}
            />
          </FieldWrapper>
        </>
      )}

      <FieldWrapper label="Gewerk">
        <MultiSelectDropdown<string>
          value={filters.gewerke}
          onChange={actions.setGewerke}
          options={gewerkOptions}
        />
      </FieldWrapper>

      <FieldWrapper label="Handwerker">
        <HandwerkerSearchSelect value={filters.technicianId} onChange={actions.setTechnicianId} />
      </FieldWrapper>
    </FilterBar>
  )
}
